import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "./index.js";

export default resolveConfig(tailwindConfig).theme as unknown as {
  colors: Record<string, string>;
};
